import { useEffect, useState } from 'react';
import {
  Table,
  Loader,
  Center,
  Text,
  Button,
} from '@mantine/core';
import { Page } from '@/components';
import Modal from '@/components/Modal';
import { useTranslation } from 'react-i18next';
import { useGetAllLeadMutation } from '@/services/api';
import { getMutationResult } from '@/helpers/query';
import classes from './lead.module.css';

const Leads = () => {
  const [data, setData] = useState([]);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedLead, setSelectedLead] = useState(null);
  const { t } = useTranslation();
  const [apiGetAllLeads] = useGetAllLeadMutation();

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const { data: result } = await getMutationResult({}, apiGetAllLeads);
        const { success, data: leadsData } = result;

        if (success) {
          setData(leadsData);
        } else {
          setIsError(true);
        }
      } catch (error) {
        setIsError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchLeads();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <Center><Loader /></Center>;
  }

  if (isError) {
    return <Center><Text c="red">{t('pages.lead.noData') }</Text></Center>;
  }

  if (!data || data.length === 0) {
    return <Center><Text>{t('pages.lead.noData') }</Text></Center>;
  }

  const headers = [
    t('pages.lead.headers.name'),
    t('pages.lead.headers.email'),
    t('pages.lead.headers.phone'),
    t('pages.lead.headers.loanAmount'),
    t('pages.lead.headers.loanType'),
    t('pages.lead.headers.actions'),
  ];

  return (
    <Page hideHelp hideNews title={t('pages.lead.title')}>
      <div className={classes.tableContainer}>
        <Table striped withColumnBorders classNames={{ tr: `${classes.changeColor}`, th: classes.changeColor, td: classes.changeColor }}>
          <Table.Thead>
            <Table.Tr className={classes.headerRow}>
              {headers.map((header, index) => (
                <Table.Th key={index}>{header}</Table.Th>
              ))}
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {data.map((lead) => (
              <Table.Tr key={lead._id}>
                <Table.Td>{lead.fullName}</Table.Td>
                <Table.Td>{lead.email}</Table.Td>
                <Table.Td>{lead.phone}</Table.Td>
                <Table.Td>{lead.offerId?.loanAmount || '-'}</Table.Td>
                <Table.Td>{lead.offerId?.period || '-'}</Table.Td>
                <Table.Td>
                  <Button size="xs" variant="outline" onClick={() => setSelectedLead(lead)}>
                    {t('pages.lead.moreInformation')}
                  </Button>
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>

        {selectedLead && (
          <Modal
            opened={true}
            close={() => setSelectedLead(null)}
            title="פרטי ליד"
            centered
          >
            <Text fw={500}>שם: {selectedLead.fullName}</Text>
            <Text>טלפון: {selectedLead.phone}</Text>
            <Text>אימייל: {selectedLead.email}</Text>
            <Text>סכום הלוואה: {selectedLead.offerId?.loanAmount || '-'}</Text>
            <Text>תקופה: {selectedLead.offerId?.period || '-'}</Text>
            <Text>סוג הלוואה: {selectedLead.offerId?.loan?.hebrew || '-'}</Text>
            <Text mt="sm" style={{ whiteSpace: 'pre-wrap' }}>
              {selectedLead.message}
            </Text>
          </Modal>
        )}
      </div>
    </Page>
  );
};

export default Leads;
